<template lang="pug">
  layout
    template(v-slot:toolbar)
      b-navbar()
        //- Tabs
        template(v-slot:start)
          ui-navbar-tabs(:items="navbarTabs")

        //- Actions
        template(v-slot:end)
          .navbar-item
            b-field
              template(v-for="action in mainActions")
                b-button.ml-10(tag="router-link" :to="action.route" :icon-left="action.icon") {{ action.label }}


    //- Content
    template(v-slot:content)
      b-table.is-clickable(:data="filteredUsers" :loading="users.$state.loading" @click="onRowClick" hoverable striped)

        b-table-column(field="id" label="ID" width="30" numeric sortable v-slot="{row}") {{ row.id }}

        b-table-column(field="fullName" label="ФИО" sortable v-slot="{row}")
          b-icon(icon="account")
          span {{ row.fullName }}

        b-table-column(field="email" label="E-mail" sortable v-slot="{row}") {{ row.email }}

        b-table-column(field="statusName" label="Статус" width="30" sortable v-slot="{row}")
          b-tag(:type="row.status ? 'is-success' : 'is-danger'") {{ row.statusName }}
          //- div(@click.stop)
            b-switch(v-model="row.status" :true-value="1" :false-value="0" @input="row.$save()" :disabled="row.id==user.id")

        b-table-column(field="actions" label="Действия" width="30" v-slot="{row}")
          ui-button.is-rounded.is-small(
            icon="pencil-circle"
            icon-type='is-info'
            :to="{name: 'control.users.edit', params: {userId: row.id}}"
          )
            |Редактировать

        //- Быстрый просмотр пользователя
        //- template(v-slot:detail="{row}"): .content
          h3 {{ row.fullName }}
            span.tag(:class="row.status ? 'is-success' : 'is-danger'") {{ row.status ? 'Активен' : 'Отключен' }}
          div(v-if="row.email") E-mail: {{ row.email }}
          div(v-if="row.phone") Телефон: {{ row.phone }}

        //- Пусто
        template(v-slot:empty)
          section.section(v-if="users.$state.loaded")
            .content.has-text-grey.has-text-centered
              p: b-icon(icon="emoticon-sad" size="is-large")
              p Нет записей
</template>

<script>
import { mapGetters } from 'vuex';
import User from '@/models/User';

const setDefaultParams = ({ name, params }, from, next) => {
  return next(params.groupId ? true : { name, params: { groupId: 1 } });
};

export default {
  name: 'view-control-users-list',

  props: {
    groupId: [String, Number],
  },

  data: () => ({
    users: User.collection(),
  }),

  computed: {
    ...mapGetters(['user', 'userGroups']),

    navbarTabs() {
      return this.userGroups.items.map(group => ({
        label: group.title,
        route: { name: 'control.users.list', params: { groupId: group.id } },
      }));
    },

    filteredUsers() {
      return this.users.items.filter(user => user.group_id === +this.groupId);
    },

    mainActions() {
      return [
        {
          label: 'Управление группами',
          icon: 'account-group',
          route: { name: 'control.settings.user-groups' },
        },
        {
          label: 'Новый пользователь',
          icon: 'account-plus',
          route: {
            name: 'control.users.create',
            params: { groupId: this.groupId },
          },
        },
      ];
    },
  },

  methods: {
    onRowClick({ id }) {
      this.$router.push({ name: 'control.users.edit', params: { userId: id } });
    },
  },

  created() {
    this.users.$fetch();

    // if (!this.groupId) {
    //   this.$router.replace({ params: { groupId: 1 } });
    // }
  },

  beforeRouteEnter: setDefaultParams,
  beforeRouteUpdate: setDefaultParams,
};
</script>
